import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'
import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import type { Offer } from '@fourthwall/services/dist/models/offer'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation } from '@tanstack/react-query'

type MutationPayload = {
  offerId: string
  params: OfferApi.SetAvailabilityPayload
}
export const useAvailabilityMutation = () => {
  const mutation = useMutation<Offer.Item, ApiError, MutationPayload>({
    mutationFn: async ({ offerId, params }) => {
      const { data } = await OffersApiClient.setAvailability(offerId, params)

      return data
    },
  })

  return {
    availability: mutation.data,
    availabilityMutation: mutation,
  }
}
